

import { useTranslation } from "react-i18next";
import { Link, generatePath } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import { ExamSession } from "../../../../types/markTypes";
import { formatToLocaleDate } from "utils/dateUtils";
import { getSubjectLabelFromCode } from "utils/schoolUtils";
import Datatable from 'components/Common/dataTable';
import { Button } from "antd";
import CustomButton from "components/Common/ui/CustomButton";

interface TeacherExamSessionListProps {
  examSessions: ExamSession[];
  loading: boolean;
  dataPaginate: any;
  onChange: (pg: any) => void;
}

const TeacherExamSessionList: React.FC<TeacherExamSessionListProps> = ({ examSessions, loading, dataPaginate, onChange }) => {

  const { t } = useTranslation();
  const getStatusIcon = (
    submissionStatus: string) => {
    switch (submissionStatus) {
      case "submitted":
        return <i className="ti ti-lock-square-rounded text-danger" style={{ marginRight: 8 }}></i>; // Locked (Red)
      case "incomplete":
        return <i className="ti ti-alert-circle text-warning" style={{ marginRight: 8 }}></i>; // Warning (Yellow)
      default:
        return <i className="ti ti-edit-circle text-success" style={{ marginRight: 8 }}></i>; // Editable (Green)
    }
  };

  const columns = [
    {
      title: t("class"),
      dataIndex: ["class", "name"],
      key: "class",
    },
    {
      title: t("subject"),
      key: "subject",
      render: (_: any, record: any) =>
        getSubjectLabelFromCode(record.subject?.code),
    },
    {
      title: t("semester"),
      dataIndex: "semester",
      key: "semester",
    },
    {
      title: t("sessions"),
      key: "sessions",
      render: (_: any, record: any) =>
        record.sessions?.length ? (
          record.sessions.map((session: any) => (
            <text
              // key={session.id}
              // to={generatePath(all_routes.ExamSessionClass, {
              //   examSessionId: session.id,
              //   classId: record.class.id,
              // })}
              className="d-block"
              style={{
                pointerEvents: session.isPublished ? "none" : "auto",
                opacity: session.isPublished ? 0.5 : 1,
              }}
            >
              {getStatusIcon(session.submissionStatus)}
              {session.name} — {formatToLocaleDate(session.startDate)}
            </text>
          ))
        ) : (
          "N/A"
        ),
    },
    {
      title: t("actions"),
      key: "actions",
      align: "center",
      render: (_: any, record: any) => (
        <CustomButton asLink to={
          generatePath(all_routes.ExamsClassSemester, {
            subjectId: record.subject.id,
            classId: record.class.id,
            semester: record.semester,
          })
        }>
          <i className="ti ti-exposure me-2"></i>
          {t('marks')}

        </CustomButton>
      ),
    },
  ];
  return (
    <Datatable loading={loading} dataSource={examSessions} columns={columns} rowKey="id" pagination={true} dataPaginate={dataPaginate} onChange={onChange} />
  );
};

export default TeacherExamSessionList;

